import Price from '~/utils/Price/Price';

export const calculatePrice = (price: Price, packageSize: number, referencePackagePrice: number): Price =>
	new Price(String((Number(price.value) / packageSize) * referencePackagePrice), price.currency);
